// extracted by mini-css-extract-plugin
export default {"container":"NoElementFound_container__37Tvn","styleImg":"NoElementFound_styleImg__JLk85","styleTitle":"NoElementFound_styleTitle__BZaUf"};